export default {
  name: 'Latest news',
  htmlId: 'latestNews',
};
